import { useSysadmin } from '@air/sysadmin';

import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useIsAirEmail } from '~/swr-hooks/useIsAirEmail';
import { isDevStage } from '~/swr-hooks/utils';

export const useInternalMenu = () => {
  const { internalMenu } = useFeatureFlags();
  const { isAirEmail } = useIsAirEmail();
  const { isInternal } = useSysadmin();

  const isInternalMenuVisible = isDevStage() || isAirEmail || !!internalMenu || isInternal;

  return { isInternalMenuVisible };
};
